import type React from "react";
import { BaseComposeInput } from "@/components/common/BaseComposeInput";
import { POST_MAX_FILE_SIZE, POST_MAX_LENGTH } from "@/constants";
import type { User } from "@/lib/humhub-api/types";

interface BasePostInputProps {
  placeholder?: string;
  submitButtonLabel?: string;
  showFormatting?: boolean;
  onSubmit?: (content: string, files?: File[]) => Promise<void>;
  className?: string;
  disabled?: boolean;
  maxFileSize?: number;
  allowedFileTypes?: string[];
  mentionUsers?: User[];
  isLoadingMentionUsers?: boolean;
  onMentionTrigger?: (query: string) => Promise<User[]>;
  compact?: boolean;
  autoFocus?: boolean;
  searchLikeWhenBlurred?: boolean;
}

export const BasePostInput: React.FC<BasePostInputProps> = ({
  placeholder,
  submitButtonLabel,
  showFormatting = true,
  onSubmit,
  className = "",
  disabled,
  maxFileSize = POST_MAX_FILE_SIZE,
  allowedFileTypes,
  mentionUsers = [],
  isLoadingMentionUsers = false,
  onMentionTrigger,
  compact = false,
  autoFocus = false,
  searchLikeWhenBlurred = false,
}) => {
  return (
    <BaseComposeInput
      placeholder={placeholder}
      submitButtonLabel={submitButtonLabel}
      showFormatting={showFormatting}
      onSubmit={onSubmit}
      className={className}
      disabled={disabled}
      maxFileSize={maxFileSize}
      maxLength={POST_MAX_LENGTH}
      allowedFileTypes={allowedFileTypes}
      onMentionTrigger={onMentionTrigger}
      mentionUsers={mentionUsers}
      isLoadingMentionUsers={isLoadingMentionUsers}
      autoFocus={autoFocus}
      compact={compact}
      searchLikeWhenBlurred={searchLikeWhenBlurred}
      context="post"
    />
  );
};
